/* eslint-disable no-restricted-syntax */
import log from 'loglevel'
import firstBy from "thenby";
import latestProdReleaseBySerialNumberReducer from '../util/filterProducts';
import { isEmpty, showGreenTick } from '../util/util';

const handleSerialNumberValidation = (responseData, dispatch, serialNumber, langStrings) => {
  log.debug('./handle/handleSerialNumberValidation called with response data: ', responseData);
  if (typeof responseData === 'object') {
    
    // got some assets
    if (responseData.filteredProduct !== undefined && responseData.filteredProduct.length > 0) {
      let isHulaEligible = true
      let isTFLEXAsset = false;
      let filteredProducts = []
      let exceptionHandled = false
      const { filteredProduct } = responseData
      for(const productDetails of filteredProduct) {
        // TFLEX, MFLEX, EFLEX check.
        if(productDetails.licensingModel !== undefined && ['TFLEX', 'MFLEX', 'EFLEX'].includes(productDetails.licensingModel)) {
          isTFLEXAsset = true;
          isHulaEligible = false
          exceptionHandled = true
          dispatch({ type: 'HULA_TFLEX'})
          break;
        }

        // deployment check - deployment type A
        else if(productDetails.deployment !== undefined && productDetails.deployment === 'A') {
          isHulaEligible = false
          exceptionHandled = true
          dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError2' });
          break;
        }

        // Logic to exclude "EDU", "EMR"
        else if(productDetails.usageType !== undefined && ['EDU', 'EMR'].indexOf(productDetails.usageType) > -1) {
          log.debug('Ineligible EDU asset. Error Message: DO NOT NEED HULA - HL-20')
          const errorDesc = langStrings.hula.requestFailedScreen.hulaIneligible || 
          `Your request can’t be completed because your product isn’t eligible for a home use license.`;
          const errorMessage = langStrings.requestFailedScreen.prodNotEligibleTitle || `Product not eligible`
          dispatch({
            type: 'UPDATE_HULA_ERROR',
            payload: {
              errorDesc,
              errorMessage,
              },
            });
          log.debug(`HL-20 - HULA's are not generated for Education asset's, Usage Type=EDU - show PRODUCT NOT ELIGIBLE`);
          dispatch({ type: 'EXPAND_FOOTER_ON_ERROR'});
          dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'HL06' }); // HL-20 === HL-06 error format.
          
          isHulaEligible = false
          exceptionHandled = true
          break;
        }

        else if (
          (productDetails.licensingModel === undefined || productDetails.licensingModel === '') && 
          (typeof productDetails.hasContractNumber !== 'undefined' && !productDetails.hasContractNumber)
          ) {
          log.debug('Ineligible perpetual asset. Error Message: ')
          const errorDesc = langStrings.processInfoScreen.ineligiblePerpetual
          dispatch({
            type: 'UPDATE_HULA_ERROR',
            payload: {
              errorDesc,
              errorMessage: '',
              },
            });
          dispatch({ type: 'HULA_NOT_ELIGIBLE'}) 
          isHulaEligible = false
          exceptionHandled = true
          break
        }

        else if(productDetails.usageType === undefined || (productDetails.usageType !== undefined && productDetails.usageType !== 'COM')) {
          log.debug('HL-12: HULA is only created for Usage Type=COM -> show PRODUCT NOT ELIGIBLE MESSAGE ')
          const errorDesc = langStrings.hula.requestFailedScreen.hulaIneligible || 
          `Your request can’t be completed because your product isn’t eligible for a home use license.`;
          const errorMessage = langStrings.requestFailedScreen.prodNotEligibleTitle || `Product not eligible`
          dispatch({
            type: 'UPDATE_HULA_ERROR',
            payload: {
              errorDesc,
              errorMessage,
              },
            });
          log.debug('HULA HL-20 Error');
          dispatch({ type: 'EXPAND_FOOTER_ON_ERROR'});
          dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'HL06' });
          isHulaEligible = false
          exceptionHandled = true
          break
        }
      }

      let eligibleAssets;
      if(isHulaEligible) {
        log.debug('<<<< HULA ELIGIBLE >>>>>>');
        filteredProducts = []
        // Remove any single user assets
        eligibleAssets = responseData.filteredProduct
          .filter(p => (
            p.deployment !== undefined && p.deployment === 'N' && p.release !== "IC"
          )).map(prd => {
            const product = prd;
            product.serialNumber = serialNumber
            return product;
          },
        )

        if (eligibleAssets.length > 0) {
          filteredProducts = eligibleAssets.reduce(
            latestProdReleaseBySerialNumberReducer, {})
            .sort(
            firstBy('productLineName', { ignoreCase: true })
              .thenBy('release', { direction: -1 }),
          )
        }

        // no N assets are remaining
        if (filteredProducts.length === 0) {
          isHulaEligible = false
        }

        if (!isHulaEligible) {
          if (!exceptionHandled && !isTFLEXAsset) {
            log.debug('Ineligible asset');
            dispatch({ type: 'MULTIUSER_DEPLOYMENT' });
          }
        } else if(filteredProducts.length === 1) {
          if(Number.isNaN(Number(filteredProducts[0].release)) || Number(filteredProducts[0].release) <= 2010) {
            log.debug('Hula Not Eligbile');
            return dispatch({ type: 'HULA_NO_LOGER_SUPPORTED'});
          }
        } else {
          // show green tick for 2 seconds.
          showGreenTick(dispatch)
          log.debug('FILTERED PRODUCT DATA : ', JSON.stringify(filteredProducts, 0, 2));
        }
      }
      return { filteredProducts, eligibleAssets };
    } 
    if(isEmpty(responseData.filteredProduct) || responseData.isInvalidSerialNumber) {
      return dispatch({ type: 'INVLID_SERIAL_NUMBER' });
    }
    return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
  } 
  return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
}
export default handleSerialNumberValidation;